import React, { useState } from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import Button from '../components/ui/Button';
import Chip from '../components/ui/Chip';

const DEPLOY_OPTIONS = [
  { icon: '▶', name: 'Google Play Store', desc: 'Publish directly to production or internal track.', connected: false },
  { icon: '⬡', name: 'Firebase App Distribution', desc: 'Share with testers instantly via email invite.', connected: true },
  { icon: '⧉', name: 'Direct Install Link', desc: 'Generate a QR code + download link for side-loading.', connected: true },
  { icon: '◈', name: 'Diawi / AppCenter', desc: 'Upload to third-party distribution platforms.', connected: false },
];

const DeployPage: React.FC = () => {
  const [selected, setSelected] = useState<string | null>('Firebase App Distribution');

  return (
    <>
      <PageHeader
        title={<><Highlight>Deploy</Highlight> App</>}
        subtitle="Distribute your APK to testers or publish to the Play Store"
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <Chip variant="info">APK Ready: app-release.apk</Chip>
        <Chip variant="success">✓ 8.3 MB</Chip>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 14, marginBottom: 28 }}>
        {DEPLOY_OPTIONS.map((opt) => (
          <div
            key={opt.name}
            onClick={() => setSelected(opt.name)}
            style={{
              background: 'var(--surface)',
              border: `1px solid ${selected === opt.name ? 'var(--accent)' : 'var(--border)'}`,
              borderRadius: 'var(--radius-lg)', padding: 20,
              cursor: 'pointer', transition: 'border-color var(--transition-base)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
              <span style={{ fontSize: 22 }}>{opt.icon}</span>
              <Chip variant={opt.connected ? 'success' : 'muted'}>{opt.connected ? '✓ Connected' : 'Setup needed'}</Chip>
            </div>
            <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 4 }}>{opt.name}</div>
            <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>{opt.desc}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        <Button variant="primary" icon="▶" disabled={!selected}>Deploy Now</Button>
        <Button variant="secondary" icon="◎">View History</Button>
      </div>
    </>
  );
};

export default DeployPage;
